import { useLocation, useNavigate } from 'react-router-dom';

import { AtashsooziOmumiPaths } from 'Feature/Atashsoozi/Constant/AtashsooziOmumiPaths';
import { LandingPaths } from 'Feature/Common/Common/Constant/LandingPaths';
import { HavadesEnferadiPaths } from 'Feature/Hadeseh/Common/Constant/HavadesEnferadiPaths';
import { KhodroShakhsSalesPaths } from 'Feature/Khodro/ShakhsSales/Routes/Paths/KhodroShakhsSalesPaths';
import { setSodoorBimehNamehByPelakInitialState } from 'Feature/Khodro/ShakhsSales/SakhsSalesBimehNameh/Pages/SodoorBimehNamehByPelak/reducers/sodoorBimehNamehByPelakSlice';
import { MosaferatiPaths } from 'Feature/Mosaferati/Common/Constant/MosaferatiPaths';
import { generateHomePageUrl } from 'Feature/Orders/Common/Actions/Thunks/generateHomePageUrl';
import { DataLayerHandler } from 'Shared/GoogleTagManager/DataLayerHandler';
import useAppDispatch from 'Shared/Store/dispatch/useAppDispatch';

export function PageConttainerViewModel() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const firstRender = async () => {
    // DataLayerHandler.addPageView(props?.title,props?.description.toLowerCase());
  };

  const navigateToWepodHomePage = () => {
    const state = localStorage.getItem('AutoLoginState');
    const stateJson = state !== null ? JSON.parse(state) : null;

    dispatch(
      generateHomePageUrl({
        correlationId: stateJson?.correlation_id,
      })
    ).then((response: any) => {
      if (response?.payload?.homePageUrl) {
        DataLayerHandler.addGoToWepod();

        const a = document.createElement('a');
        a.href = response.payload.homePageUrl;
        a.referrerPolicy = 'no-referrer';
        a.click();
      }
    });
  };

  const handleBack = () => {
    let urlRoute = location.pathname;
    if (location.pathname.includes('/Order/Detail')) urlRoute = LandingPaths.Landing.OrderDetail;

    switch (urlRoute) {
      case KhodroShakhsSalesPaths.BimehNameh.SodoorByPelak:
        dispatch(setSodoorBimehNamehByPelakInitialState());
        navigate(LandingPaths.Landing.Main);
        break;

      case KhodroShakhsSalesPaths.BimehNameh.Detail:
        window.history.back();
        break;

      case KhodroShakhsSalesPaths.BimehNameh.ElhaghiyehSaderehDetail:
        navigate(`${LandingPaths.Landing.OrderHistoryOrElhaghieh}/${encodeURIComponent('ELHAGHIEH')}`);
        break;

      case HavadesEnferadiPaths.BimehNameh.Detail:
        window.history.back();
        break;

      // case AtashsooziOmumiPaths.BimehNameh.Sodoor:
      //     clearResultAtashsoozi();
      //     break;

      case AtashsooziOmumiPaths.BimehNameh.Detail:
        window.history.back();
        break;

      // case MosaferatiPaths.BimehNameh.Sodoor:
      //     clearResultMosaferati();
      //     break;

      case MosaferatiPaths.BimehNameh.Detail:
        window.history.back();
        break;

      case LandingPaths.Landing.OrderDetail:
        navigate(`${LandingPaths.Landing.OrderHistoryOrElhaghieh}/${encodeURIComponent('HISTORY')}`);
        break;

      case LandingPaths.Landing.Main:
        navigateToWepodHomePage();
        break;

      default:
        navigate(-1);
        break;
    }
  };
  return {
    handleBack,
    firstRender,
  };
}
